import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import { Link } from "react-router-dom";
import HealthSystem from "./HealthSystem";
import Hospital from "./Hospital";
import Procedure from "./Procedure";
import ServiceLine from "./ServiceLine";
import UserTabSettings from "./UsersTabSettings";
import $ from "jquery";
import Patient from "./Patients";
import Physician from "./Physician";
import ViewForPhysicianTabSettings from "./ViewForPhysicianTabSettings";
import Billing from "./Billing";
import ErrorBoundary from "../../ErrorBoundary";
import Feedback from "./Feedback";
import RiskRuleForProcedure from "./RiskRuleForProcedure";

class AdminNavigationBar extends Component {
  constructor() {
    super();
    this.state = {
      showHomeEnityName: localStorage.getItem("homeEntityName"),
      showFromHealthSystemTab: false,
      showFromHospitalTab: false,
      showFromServiceLineTab: false,
      showFromProcedureTab: false,
      showFromStaffTab: false,
      showFromPatientTab: false,
      rootAdmin: false,
      healthSystemAdmin: false,
      hospitalAdmin: false,
      serviceLineAdmin: false,
      procedureAdmin: false,
      physician: false,
      nurse: false,
      patient: false,
      topHeading: "",
    };
    window.adminNavigationBar = this;
  }

  componentDidMount() {
    this.paintHeading();
    var userDetails = localStorage.getItem("user_details");
    if(!userDetails) return;
    var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
    if (userRole == "ADMIN") {
      this.state.showFromHealthSystemTab = true;
      this.state.showFromHospitalTab = true;
      this.state.showFromServiceLineTab = true;
      this.state.showFromProcedureTab = true;
      this.state.showFromStaffTab = true;
      this.state.showNurseRoleView = true;
      this.state.showFromPatientTab = true;
      this.state.rootAdmin = true;

      this.setState(this.state);
    }
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      this.state.showFromHospitalTab = true;
      this.setState(this.state);
    } else if (userRole == "HOSPITAL_ADMIN") {
      this.state.showFromServiceLineTab = true;
      this.state.showFromProcedureTab = true;
      this.state.showNurseRoleView = true;
      this.state.showFromPatientTab = true;
      this.state.showFromStaffTab = true;
      this.state.hospitalAdmin = true;

      this.setState(this.state);
    } else if (userRole == "SERVICELINE_ADMIN") {
      this.state.showFromProcedureTab = true;
      this.state.showNurseRoleView = true;
      this.state.showFromPatientTab = true;
      this.state.showFromStaffTab = true;
      this.state.serviceLineAdmin = true;

      this.setState(this.state);
    } else if (userRole == "PHYSICIAN") {
      this.state.physician = true;

      this.setState(this.state);
    } else {
      this.setState(this.state);
    }

    if (!this.tabClickHandlerDefined) {
      this.tabClickHandlerDefined = true;
      var selectedTab = localStorage.getItem("admin-nav-bar-selection");
      $("#healthsystems,#hospital,#serviceline,#procedure,#staff,#patient,#billing,#feedback").on(
        "click",
        function () {
          $(
            "#healthsystems,#hospital,#serviceline,#procedure,#staff,#patient,#billing,#feedback"
          ).removeClass("active");
          localStorage.setItem("admin-nav-bar-selection", $(this)[0].id);
          $(this).addClass("active");
        }
      );

      var selectedTab = localStorage.getItem("admin-nav-bar-selection");
      if (selectedTab) {
        $("#" + selectedTab).addClass("active");
      }

      window.addEventListener("popstate", function (event) {

        $(
          "#healthsystems,#hospital,#serviceline,#procedure,#staff,#patient,#billing,#feedback"
        ).removeClass("active");
        var defaultSelection = false;
        var userRole = JSON.parse(localStorage.getItem("user_details"))[
          "userRole"
        ];
        var currentPath = window.location.href;

        if (
          currentPath.includes("/projectmgmt/hospital") ||
          currentPath.includes("/projectmgmt/hospital/")
        ) {
          defaultSelection = "hospital";
        } else if (
          currentPath.includes("/projectmgmt/service-line") ||
          currentPath.includes("/projectmgmt/service-line/")
        ) {
          defaultSelection = "serviceline";
        } else if (
          currentPath.includes("/projectmgmt/procedure") ||
          currentPath.includes("/projectmgmt/procedure/")
        ) {
          defaultSelection = "procedure";
        } else if (
          currentPath.includes("/projectmgmt/staff") ||
          currentPath.includes("/projectmgmt/staff/")
        ) {
          defaultSelection = "staff";
        } else if (
          currentPath.includes("/projectmgmt/patient") ||
          currentPath.includes("/projectmgmt/patient/")
        ) {
          defaultSelection = "patient";
        } else if (
          currentPath.includes("/projectmgmt/billing") ||
          currentPath.includes("/projectmgmt/billing/")
        ) {
          defaultSelection = "billing";
        } else if (
          currentPath.includes("/projectmgmt/feedback") ||
          currentPath.includes("/projectmgmt/feedback/")
        ) {
          defaultSelection = "feedback";
        } else {
          if (userRole == "ADMIN") {
            defaultSelection = "healthsystems";
          } else if (userRole == "HEALTHSYSTEM_ADMIN") {
            defaultSelection = "hospital";
          } else if (userRole == "HOSPITAL_ADMIN") {
            defaultSelection = "serviceline";
          } else if (userRole == "SERVICELINE_ADMIN") {
            defaultSelection = "procedure";
          } else if (userRole == "PHYSICIAN") {
            defaultSelection = "staff";
          }
        }

        if (defaultSelection !== false) {
          $("#adminNavMenu #" + defaultSelection).addClass("active");
          localStorage.setItem("admin-nav-bar-selection", defaultSelection);
          return;
        }

        var lastSelection = localStorage.getItem("admin-nav-bar-selection");
        if (lastSelection) {
          $("#adminNavMenu #" + "lastSelection").addClass("active");
          localStorage.setItem("admin-nav-bar-selection", defaultSelection);
          return;
        }
      });
    }

    this.markActiveTab();
  }

  // markActiveTab() {
  //   var defaultSelection = false;
  //   var userDetails = localStorage.getItem("user_details");
  //   if (userDetails !== null) {
  //     var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
  //     var currentPath = window.location.href;

  //     if (
  //       currentPath.includes("/projectmgmt/hospital") ||
  //       currentPath.includes("/projectmgmt/hospital/")
  //     ) {
  //       defaultSelection = "hospital";
  //     } else if (
  //       currentPath.includes("/projectmgmt/service-line") ||
  //       currentPath.includes("/projectmgmt/service-line/")
  //     ) {
  //       defaultSelection = "serviceline";
  //     } else if (
  //       currentPath.includes("/projectmgmt/procedure") ||
  //       currentPath.includes("/projectmgmt/procedure/")
  //     ) {
  //       defaultSelection = "procedure";
  //     } else if (
  //       currentPath.includes("/projectmgmt/staff") ||
  //       currentPath.includes("/projectmgmt/staff/")
  //     ) {
  //       defaultSelection = "staff";
  //     } else if (
  //       currentPath.includes("/projectmgmt/patient") ||
  //       currentPath.includes("/projectmgmt/patient/")
  //     ) {
  //       defaultSelection = "patient";
  //     } else if (
  //       currentPath.includes("/projectmgmt/billing") ||
  //       currentPath.includes("/projectmgmt/billing/")
  //     ) {
  //       defaultSelection = "billing";
  //     } else if (
  //       currentPath.includes("/projectmgmt/feedback") ||
  //       currentPath.includes("/projectmgmt/feedback/")
  //     ) {
  //       defaultSelection = "feedback";
  //     } else {
  //       if (userRole == "ADMIN") {
  //         defaultSelection = "healthsystems";
  //       } else if (userRole == "HEALTHSYSTEM_ADMIN") {
  //         defaultSelection = "hospital";
  //       } else if (userRole == "HOSPITAL_ADMIN") {
  //         defaultSelection = "serviceline";
  //       } else if (userRole == "SERVICELINE_ADMIN") {
  //         defaultSelection = "procedure";
  //       } else if (userRole == "PHYSICIAN") {
  //         defaultSelection = "staff";
  //       }
  //     }

  //     if (defaultSelection !== false) {
  //       $("#adminNavMenu #" + defaultSelection).addClass("active");
  //       localStorage.setItem("admin-nav-bar-selection", defaultSelection);
  //       return;
  //     }

  //     var lastSelection = localStorage.getItem("admin-nav-bar-selection");
  //     if (lastSelection) {
  //       $("#adminNavMenu #" + "lastSelection").addClass("active");
  //       localStorage.setItem("admin-nav-bar-selection", defaultSelection);
  //       return;
  //     }

  //     var path = window.origin + "/my-jeeva/projectmgmt";
  //     var path1 = window.origin + "/my-jeeva/projectmgmt/";
  //     if (currentPath == path || currentPath == path1) {
  //       if (this.state.rootAdmin == true) {
  //         defaultSelection = "healthsystems";
  //       } else if (
  //         this.state.healthSystemAdmin == true ||
  //         this.state.showFromHospitalTab == true
  //       ) {
  //         defaultSelection = "hospital";
  //       } else if (this.state.hospitalAdmin == true) {
  //         defaultSelection = "hospital";
  //       } else if (this.state.serviceLineAdmin == true) {
  //         defaultSelection = "procedure";
  //       } else if (this.state.procedureAdmin) {
  //         defaultSelection = "staff";
  //       } else if (this.state.patient == true || this.state.nurse == true) {
  //         defaultSelection = "patient";
  //       }
  //     }

  //     $("#adminNavMenu #" + defaultSelection).addClass("active");
  //     localStorage.setItem("admin-nav-bar-selection", defaultSelection);
  //   }

  // }

  markActiveTab() {
    const userDetails = localStorage.getItem("user_details");
    if (!userDetails) return;
  
    const { userRole } = JSON.parse(userDetails);
    const currentPath = window.location.href;
  
    const pathTabMap = {
      hospital: "hospital",
      "service-line": "serviceline",
      procedure: "procedure",
      staff: "staff",
      patient: "patient",
      billing: "billing",
      feedback: "feedback",
    };
  
    const roleTabMap = {
      ADMIN: "healthsystems",
      HEALTHSYSTEM_ADMIN: "hospital",
      HOSPITAL_ADMIN: "serviceline",
      SERVICELINE_ADMIN: "procedure",
      PHYSICIAN: "staff",
    };
  
    const stateTabMap = [
      { flag: this.state.rootAdmin, tab: "healthsystems" },
      { flag: this.state.healthSystemAdmin || this.state.showFromHospitalTab, tab: "hospital" },
      { flag: this.state.hospitalAdmin, tab: "hospital" },
      { flag: this.state.serviceLineAdmin, tab: "procedure" },
      { flag: this.state.procedureAdmin, tab: "staff" },
      { flag: this.state.patient || this.state.nurse, tab: "patient" },
    ];
  
    let defaultSelection = false;
  
    const matchedPath = Object.keys(pathTabMap).find((key) =>
      currentPath.includes(`/projectmgmt/${key}`)
    );
    if (matchedPath) {
      defaultSelection = pathTabMap[matchedPath];
    }
  
    if (!defaultSelection) {
      defaultSelection = roleTabMap[userRole] || false;
    }
  
    if (defaultSelection) {
      $("#adminNavMenu #" + defaultSelection).addClass("active");
      localStorage.setItem("admin-nav-bar-selection", defaultSelection);
      return;
    }
  
    const lastSelection = localStorage.getItem("admin-nav-bar-selection");
    if (lastSelection) {
      $("#adminNavMenu #" + lastSelection).addClass("active"); 
      localStorage.setItem("admin-nav-bar-selection", lastSelection);
      return;
    }
  
    const rootPath = window.origin + "/my-jeeva/projectmgmt";
    if (currentPath === rootPath || currentPath === rootPath + "/") {
      const stateMatch = stateTabMap.find(({ flag }) => flag);
      if (stateMatch) defaultSelection = stateMatch.tab;
    }
  
    if (defaultSelection) {
      $("#adminNavMenu #" + defaultSelection).addClass("active");
      localStorage.setItem("admin-nav-bar-selection", defaultSelection);
    }
  }

  paintHeading = () => {
    var healthSystemName = localStorage.getItem("healthSystemName");
    var hospitalName = localStorage.getItem("hospitalName");
    var serviceLineName = localStorage.getItem("serviceName");

    if (hospitalName == "Select Hospital" || hospitalName == "null") {
      hospitalName = null;
    }
    if (serviceLineName == "Select Service Line" || serviceLineName == "null") {
      serviceLineName = null;
    }

    var heading = "";
    if (healthSystemName) {
      heading = healthSystemName;
      if (hospitalName) {
        heading = hospitalName + " | " + heading;
        if (serviceLineName) {
          heading = serviceLineName + " | " + heading;
        }
      }
    }
    if (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HOSPITAL_ADMIN) {
      heading = this.state.showHomeEnityName;
      if (serviceLineName) {
        heading = serviceLineName + " | " + this.state.showHomeEnityName;
      }
    }
    this.state.topHeading = heading;
    this.setState(this.state);
  }

  getHomePage = () => {
    if (this.state.physician === true) {
      console.log("HomeContent:ViewForPhysicianTabSettings");
      return ViewForPhysicianTabSettings;
    }
    if (this.state.showFromHealthSystemTab === true) {
      console.log("HomeContent:HealthSystem");
      return HealthSystem;
    }
    if (this.state.showFromHospitalTab === true) {
      console.log("HomeContent:Hospital");
      return Hospital;
    }
    if (this.state.showFromServiceLineTab === true) {
      console.log("HomeContent:ServiceLine");
      return ServiceLine;
    }
    if (this.state.showFromProcedureTab === true) {
      console.log("HomeContent:Procedure");
      return Procedure;
    }
    if (this.state.showFromPatientTab === true) {
      console.log("HomeContent:Patient");
      return Patient;
    }
    console.log("HomeContent:UserTabSettings");
    return UserTabSettings;
  };


  render() {
    this.markActiveTab();
    return (
      <ErrorBoundary>
        <div id="tabPage">
          <div className="content" style={{ backgroundColor: "#F9F9FB" }}>
            <link
              rel="shortcut icon"
              type="image/png"
              href="assets/images/bot.ico"
            />
            <title> Dheeyantra | Clusters Details</title>
            {/* Font Awesome Icons */}
            <link
              rel="stylesheet"
              href="plugins/font-awesome/css/font-awesome.min.css"
            />
            {/* IonIcons */}
            <link
              rel="stylesheet"
              href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
            />
            <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
            {/* Theme style */}
            <link rel="stylesheet" href="assets/css/adminlte.css" />
            <link
              href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
              rel="stylesheet"
            />
            <link rel="stylesheet" href="assets/css/custom-style.css" />
            <link rel="stylesheet" href="assets/css/styles.css" />
            <link rel="stylesheet" href="assets/css/custom-style.css" />

            <div className="content-header">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-sm-4">
                    <h1 className="m-0 page-title">Administration</h1>
                  </div>
                  <div className="col-sm-8" style={{ textAlign: "right" }}>
                    <h1 className="m-0 page-title" style={{ textAlign: "right" }}>
                      {this.state.showHomeEnityName == "Application Admin" || window.SCOPE_VALUE.CURRENT ==
                        window.SCOPE_VALUE.HOSPITAL_ADMIN
                        ? this.state.topHeading
                        : this.state.showHomeEnityName}
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div className="container-fluid">
              {/* Nav tabs */}
              <div className="border-bottom" style={{ marginLeft: "1vw" }}></div>
              <div className="tab-class" style={{ marginLeft: "1vw" }}>
                <ul
                  className="nav nav-tabs border-bottom navCluster"
                  id="adminNavMenu"
                >
                  <Link
                    className="nav-item"
                    data-toggle="tab"
                    to="/projectmgmt"
                    style={{ textDecoration: "none" }}
                  >
                    <li
                      className="nav-link"
                      id="healthsystems"
                      style={{
                        marginRight: "15px",
                        display: this.state.showFromHealthSystemTab
                          ? "block"
                          : "none",
                      }}
                    >
                      Health Systems
                    </li>
                  </Link>

                  <Link
                    className="nav-item"
                    data-toggle="tab"
                    to={
                      this.state.hospitalAdmin
                        ? "/projectmgmt"
                        : "/projectmgmt/hospital"
                    }
                    style={{ textDecoration: "none" }}
                  >
                    <li
                      className="nav-link"
                      id="hospital"
                      style={{
                        marginRight: "15px",
                        display: this.state.showFromHospitalTab
                          ? "block"
                          : "none",
                      }}
                    >
                      Hospital
                    </li>
                  </Link>

                  <Link
                    className="nav-item"
                    data-toggle="tab"
                    to={
                      this.state.serviceLineAdmin
                        ? "/projectmgmt"
                        : "/projectmgmt/service-line"
                    }
                    style={{ textDecoration: "none" }}
                  >
                    <li
                      className="nav-link"
                      id="serviceline"
                      style={{
                        marginRight: "15px",
                        display: this.state.showFromServiceLineTab
                          ? "block"
                          : "none",
                      }}
                    >
                      Service Line
                    </li>
                  </Link>
                  <Link
                    className="nav-item"
                    data-toggle="tab"
                    to={
                      this.state.procedureAdmin
                        ? "/projectmgmt"
                        : "/projectmgmt/procedure"
                    }
                    style={{ textDecoration: "none" }}
                  >
                    <li
                      className="nav-link"
                      id="procedure"
                      style={{
                        marginRight: "15px",
                        display: this.state.showFromProcedureTab
                          ? "block"
                          : "none",
                      }}
                    >
                      Treatment
                    </li>
                  </Link>
                  <Link
                    className="nav-item"
                    data-toggle="tab"
                    to={
                      this.state.physician ? "/projectmgmt" : "/projectmgmt/staff"
                    }
                    style={{ textDecoration: "none" }}
                  >
                    <li
                      className="nav-link"
                      id="staff"
                      style={{
                        marginRight: "15px",
                        display: this.state.showFromStaffTab ? "block" : "none",
                      }}
                    >
                      Provider
                    </li>
                  </Link>
                  {/* <Link
                  className="nav-item"
                  data-toggle="tab"
                  to="/projectmgmt/billing"
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className="nav-link"
                    id="billing"
                    style={{
                      marginRight: "15px",
                    }}
                  >
                   Billing
                  </li>
                </Link> */}
                  <Link
                    className="nav-item"
                    data-toggle="tab"
                    to="/projectmgmt/feedback"
                    style={{ textDecoration: "none" }}
                  >
                    <li
                      className="nav-link"
                      id="feedback"
                      style={{
                        marginRight: "15px",
                        display: this.state.rootAdmin
                          ? "block"
                          : "none",
                      }}
                    >
                      Feedback
                    </li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>
          <Switch>
            <Route path="/projectmgmt/staff" component={Physician}></Route>
            <Route path="/projectmgmt/procedure" component={Procedure}></Route>
            <Route path="/projectmgmt/service-line" component={ServiceLine}></Route>
            <Route path="/projectmgmt/hospital" component={Hospital}></Route>
            <Route path="/projectmgmt/billing" component={Billing}></Route>
            <Route path="/projectmgmt/feedback" component={Feedback}></Route>
            <Route path="/projectmgmt/procedure/risk-rule" component={RiskRuleForProcedure}></Route>
            <Route exact path="/projectmgmt" component={this.getHomePage()}></Route>
          </Switch>
        </div>
      </ErrorBoundary>
    );
  }
}
export default AdminNavigationBar;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/AdminNavigationBar.js